// Storage keys for offline auth
export const OFFLINE_AUTH_KEY = 'offline_auth_data'
export const OFFLINE_USER_KEY = 'offline_user_data'
export const OFFLINE_TOKEN_KEY = 'offline_token_data'

export interface OfflineAuthData {
    lastOnlineAuth: string
    userInfo: any
    tokenInfo: any
}
